import { render, staticRenderFns } from "./qna_modi.vue?vue&type=template&id=78f08dec&scoped=true&"
import script from "./qna_modi.vue?vue&type=script&lang=js&"
export * from "./qna_modi.vue?vue&type=script&lang=js&"
import style0 from "./qna_modi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./qna_modi.vue?vue&type=style&index=1&id=78f08dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f08dec",
  null
  
)

export default component.exports